import {ReactNode} from 'react';
import styled from 'styled-components';
import {ActionGuideTooltip} from '@/components/Tooltip';
import {FlexFullGrow, interceptProps} from '@/styled-components';
import {FULL_SCREEN, palette, Z_INDEX} from '@/styles';
import ArrowIcon from './assets/double-arrow.svg';
import {Infomation} from './Infomation';

interface IProps {
  open?: boolean;
  id?: string;
  children: ReactNode;
  onClose?(): void;
}

export const AiPromptPanel = ({open, children, onClose}: IProps) => {
  return (
    <Root open={open}>
      <ActionGuideTooltip content="닫기" place="left" offset={6}>
        <CloseButton onClick={onClose} />
      </ActionGuideTooltip>
      <Header>
        상권 분석 AI 해설
        <Infomation />
        <FlexFullGrow />
        <Beta>AI beta</Beta>
      </Header>
      {children}
    </Root>
  );
};

const Root = styled('div').withConfig({
  shouldForwardProp: interceptProps(['open']),
})<{
  open?: boolean;
}>`
  position: absolute;
  display: flex;
  flex-direction: column;
  right: -500px;
  top: 8px;
  width: 298px;
  height: calc(${FULL_SCREEN.vh} - 124px);
  border-radius: 12px;
  background-color: ${palette.white};
  border: solid 1px ${palette.gray150};
  box-shadow: -2px 1px 20px 0px rgba(0, 0, 0, 0.1);
  z-index: ${Z_INDEX.mapSide};
  transition: right 500ms;
  ${({open}) =>
    open &&
    `
    right: 8px;
    `}
`;

const CloseButton = styled.button`
  width: 32px;
  height: 32px;
  fill: ${palette.white};
  filter: drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.1));
  border-radius: 100%;
  position: absolute;
  left: -18px;
  top: 80px;
  background-image: url(${ArrowIcon});
  background-position: center;
  background-repeat: no-repeat;
  background-color: ${palette.white};
  cursor: pointer;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  color: ${palette.black};
  font-size: 16px;
  font-weight: 700;
  gap: 4px;
  border-bottom: solid 1px ${palette.gray200};
  flex-shrink: 0;
`;

const Beta = styled.div`
  border-radius: 4px;
  border: solid 1px ${palette.gray200};
  padding: 2px 4px;
  color: ${palette.gray600};
  font-size: 12px;
  font-weight: 400;
  cursor: default;
`;
